/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { IFile } from 'ui/src/components/Upload/sharedTypes'
import { UploadFileTypeEnum } from 'viterbit-api-sdk'

import { FileResponse, UploadFilePayload } from '../dto/files'
import { FileModel } from '../model/File.model'

const fileMapper = {
    toModel: (dto: FileResponse): FileModel => ({
        id: dto.id,
        name: dto.name,
        size: dto.size,
        type: dto.mimeType,
        kind: dto.type as UploadFileTypeEnum,
        url: dto.url || `/api/files/${dto.type}/${dto.id}`,
        mimeType: dto.mimeType,
        extension: dto.extension,
    }),
    modelToIFile: ({id, name, size, type, url,}: FileModel): IFile => ({
        id,
        name,
        size,
        kind: type,
        url,
    }),
    iFileToUploadPayload: ({ _meta }: IFile, kind: UploadFileTypeEnum, employeeId: string): UploadFilePayload => ({
        file: _meta!.file,
        type: kind,
        employeeId,
    })
}

export default fileMapper
